import { useToaster } from '@gravity-ui/uikit';
import { useCallback } from 'react';

// Типы для конфигурации уведомлений
export interface NotificationConfig {
  name: string;
  title: string;
  content?: string;
  theme: 'info' | 'success' | 'warning' | 'danger';
}

/**
 * Хук для работы с уведомлениями
 * @returns {Function} createNotification - функция для создания уведомлений
 */
export const useNotifications = () => {
  const { add: addToast } = useToaster();

  // Функция для создания уведомлений
  const createNotification = useCallback((config: NotificationConfig) => {
    addToast(config);
  }, [addToast]);

  return { createNotification };
}; 